import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // 主页
    {
      path: '/:week/:times',
      name: 'index',
      component: () => import(/* webpackChunkName: "index" */ './views/index.vue'),
      beforeEnter: (to, from, next) => {
        // 保存token到全局对象
        if (!window.token) {
          window.token = to.query.token;
        }
        // 如果没有用户信息,先获取用户信息
        if (!store.getters.userInfo) {
          store.dispatch('setUser');
        }
        next();
      },
      children: [
        // 人机
        {
          path: 'manMachine',
          name: 'manMachine',
          component: () => import(/* webpackChunkName: "manMachine" */ './views/manMachine.vue'),
          meta: {
            title: '对弈',
          },
        },
        // 人机对战记录详情
        {
          path: 'manETResult',
          name: 'manETResult',
          component: () => import(/* webpackChunkName: "manETResult" */ './views/manETResult.vue'),
          meta: {
            title: '对弈记录',
          },
        },
        // 打谱
        {
          path: 'todoDp',
          name: 'todoDp',
          component: () => import(/* webpackChunkName: "todoDp" */ './views/todoDp.vue'),
          meta: {
            title: '打谱',
          },
        },
        // 做题
        {
          path: 'doTopic',
          name: 'doTopic',
          component: () => import(/* webpackChunkName: "doTopic" */ './views/doTopic.vue'),
          meta: {
            title: '做题',
          },
        },
        // 任务--测试
        {
          path: 'doTest',
          name: 'doTest',
          component: () => import(/* webpackChunkName: "doTest" */ './views/doTest.vue'),
          meta: {
            title: '测验',
          },
        },
        // 任务--问答
        {
          path: 'askQuestion',
          name: 'askQuestion',
          component: () => import(/* webpackChunkName: "askQuestion" */ './views/askQuestion.vue'),
          meta: {
            title: '问答',
          },
        },
      ],
    },
  ],
});
